export default __webpack_public_path__ + "static/docker-6a1c2220a00d3844eea00d18c9780af0.png";